module.exports = new __parcel__URL__("fileCabinet.17ae0554.svg").toString();